// The "starter" network that shows when opened

import { MarkerType } from 'reactflow';

let enable = true; //true = load starter network, false = blank network

let nodes = []
let edges = []

if (enable) {
  nodes = [
    {
      id: 'fuel',
      type: 'customNode',
      data: { label: 'Fuel Supply',  
      states: [{'Present': 0.9}, {'No Fuel': 0.1}], 
      parentData: {}, 
      setStates: [{S1:0}, {S2:0}],
      condProb:[{S1:0.9}, {S2:0.1}], funcs: {}
        },
      position: {
        "x": 717.3080987221692,
        "y": -139.52581247084478
    },
    },
    {
      id: 'gen',
      type: 'customNode',
      data: { label: 'Generator',  
      states: [{'Operational': 0.4}, {'Damaged': 0.6}], 
      // parentData: [{"fuel": [{'present': 0.9}, {'no_fuel': 0.1}]}],
      parentData: {1: {'fuel': {1: 'present', 2: 'no_fuel'}}},
      setStates: [{S1:0}, {S2:0}],
      condProb: [{S1:[{P1C1:0.99}, {P1C2:0.0}]}, {S2:[{P1C1:0.01}, {P1C2:1}]}], funcs: {}
        },
      position: {
        "x": 386.1260527865567,
        "y": -92.31454119512495
    },
    },
    {
      id: 'ant',
      type: 'customNode',
      data: { label: 'Antenna',  
      states: [{'Operational': 0.8}, {'Damaged': 0.2}], 
      parentData: {},
      setStates: [{S1:0}, {S2:0}],
      condProb:[{S1:0.8}, {S2:0.2}], 
      funcs: {}
      },   
      position: {
        "x": 20.93134996044057,
        "y": -137.36443413890925
    },
    },
    {
      id: 'rad',
      type: 'customNode',
      data: { label: 'Radar',  
      states: [{'Operational': 0.4}, {'Damaged': 0.6}], 
      // parentData: [{"gen": [{'Operational': 0.4}, {'Damaged': 0.6}]}, {"ant": [{'Operational': 0.8}, {'Damaged': 0.2}]}],
      parentData: {1: {"gen": {1: "Operational", 2: "Damaged"}}, 2: {"ant": {1: "Operational", 2: "Damaged"}}},
      setStates: [{S1:0}, {S2:0}],
      condProb: [
        {S1:[
          {P1C1: [{P2C1: 0.99}, {P2C2: 0.8}]},
          {P1C2: [{P2C1: 0.1}, {P2C2: 0.99}]}]},
        {S2:[
          {P1C1: [{P2C1: 0.01}, {P2C2: 0.2}]},
          {P1C2: [{P2C1: 0.9}, {P2C2: 0.01}]}]}], 
        funcs: {}
        },
      position: {
        "x": 166.05436974006182,
        "y": 182.53440130040892
    },
    },
    {
      id: 'com',
      type: 'customNode',
      data: { label: 'Communications',  
      states: [{'Operational': 0.95}, {'Damaged': 0.5}], 
      // parentData: [{"gen": [{'Operational': 0.89}, {'Damaged': 0.11}]}],
      parentData: {1: {"gen": {1: "Operational", 2: "Damaged"}}},
      setStates: [{S1:0}, {S2:0}],
      condProb: [{S1:[{P1C1:0.98}, {P1C2:0.7}]}, {S2:[{P1C1:0.02}, {P1C2:0.3}]}], funcs: {}
        }, 
      position: {
        "x": 605.1389096613185,
        "y": 195.57072187530383
    },
    },
    {
      id: 'comcen',
      type: 'customNode',
      data: { label: 'Command Center',  
      states: [{'Operational': 0.4}, {'Damaged': 0.6}], 
        // parentData: [{"rad": [{'Operational': 0.4}, {'Damaged': 0.6}]}, {"com": [{'Operational': 0.95}, {'Damaged': 0.5}]}],
        parentData: {1: {"rad": {1: "Operational", 2: "Damaged"}}, 2: {"com": {1: "Operational", 2: "Damaged"}}},
        setStates: [{S1:0}, {S2:0}],
        condProb: [
          {S1:[
            {P1C1: [{P2C1: 0.99}, {P2C2: 0.9}]},
            {P1C2: [{P2C1: 0.4}, {P2C2: 0.1}]}]},
          {S2:[
            {P1C1: [{P2C1: 0.01}, {P2C2: 0.1}]},
            {P1C2: [{P2C1: 0.6}, {P2C2: 0.9}]}]}],
             funcs: {}
      }, 
      position: {
        "x": 351.7251463906126,
        "y": 494.25107359294293
    },
    },
    
  ];
  
  edges = [
    {
        "source": "fuel",
        "sourceHandle": null,
        "target": "gen",
        "targetHandle": null,
        "type": "customEdge",
        "markerEnd": {type: MarkerType.ArrowClosed, fill: "black"},
        "interactionWidth": 200,
        "data": {
            "funcs": {}
        },
        "id": "reactflow__edge-fuel-gen"
    },
    {
        "source": "gen",
        "sourceHandle": null,
        "target": "rad",
        "targetHandle": null,
        "type": "customEdge",
        "markerEnd": {type: MarkerType.ArrowClosed, fill: "black"},
        "interactionWidth": 200,
        "data": {
            "funcs": {}
        },
        "id": "reactflow__edge-gen-rad"
    },
    {
        "source": "gen",
        "sourceHandle": null,
        "target": "com",
        "targetHandle": null,
        "markerEnd": {type: MarkerType.ArrowClosed, fill: "black"},
        "type": "customEdge",
        "interactionWidth": 200,
        "data": {
            "funcs": {}
        },
        "id": "reactflow__edge-gen-com"
    },
    {
        "source": "ant",
        "sourceHandle": null,
        "target": "rad",
        "targetHandle": null,
        "type": "customEdge",
        "markerEnd": {type: MarkerType.ArrowClosed, fill: "black"},
        "interactionWidth": 200,
        "data": {
            "funcs": {}
        },
        "id": "reactflow__edge-ant-rad"
    },
    {
        "source": "rad",
        "sourceHandle": null,
        "target": "comcen",
        "targetHandle": null,
        "markerEnd": {type: MarkerType.ArrowClosed, fill: "black"},
        "type": "customEdge",
        "interactionWidth": 200,
        "data": {
            "funcs": {}
        },
        "id": "reactflow__edge-rad-comcen"
    },
    {
        "source": "com",
        "sourceHandle": null,
        "target": "comcen",
        "markerEnd": {type: MarkerType.ArrowClosed, fill: "black"},
        "targetHandle": null,
        "type": "customEdge",
        "interactionWidth": 200,
        "data": {
            "funcs": {}
        },
        "id": "reactflow__edge-com-comcen"
    }
  ]
}

export { nodes, edges }
